export default "__VITE_ASSET__CpTfWRAS__"